﻿
import angular from 'angular';

import './cart-product';
import '../../../services/cart';
import '../../../services/datastorage';

angular.module('folkeuni').component('cart', {
  bindings: {
    cart: '=',
    state: '<',
    siteId: '<',
  },
  controller: function(Cart, DataStorage, $location, $window) {
  },
  templateUrl: '/shop-dist/templates/cart.html?c=' + window.cacheBurst,
});
